import React from 'react';
import JobTable from 'views/Company/Jobs/JobTable';

const JobManagement = () => {
    return (
        <div>
            <JobTable/>
        </div>
    )
}

export default JobManagement;